export class Pagination {
  private items: Array<any>;
  private currentPage: number = 1;
  private perPage: number = 7;
  private totalPages: number = 1;
  public currentItems: Array<any> = [];
  public hasPages: boolean = false;
  public isFirstPage: boolean = true;
  public isLastPage: boolean = true;

  constructor(items: Array<any>, perPage?: number) {
    this.items = items;
    if (perPage) {
      this.perPage = perPage;
    }
    this.totalPages = Math.ceil(items.length/this.perPage);
    this.hasPages = this.totalPages > 1;
    this.updatePage();
  }

  private updatePage() {
    this.isFirstPage = this.currentPage == 1;
    this.isLastPage = this.currentPage == this.totalPages;
    this.currentItems = this.getCurrentItems();
  }

  public getCurrentItems(): Array<any> {
    return this.items.slice((this.currentPage-1)*this.perPage, this.currentPage*this.perPage);
  }

  public next() {
    if (!this.isLastPage) {
      this.currentPage++;
      this.updatePage();
    } 
  }

  public prev() {
    if (!this.isFirstPage) {
      this.currentPage--;
      this.updatePage();
    } 
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/helpers/pagination.ts